import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Fab,
  Tooltip,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import { defineMessages, FormattedMessage } from 'react-intl';

import styles from '../styles.module.css';
import * as actions from '../../../../state';
import { deleteChart, rememberBoard } from '../../../../events';
import ChartCard from './ChartCard';

// localization
const messages = defineMessages({
  COPY_CHART: {
    id: 'COPY_CHART',
    defaultMessage: 'Copy Chart',
  },
  CHART_COPIED: {
    id: 'CHART_COPIED',
    defaultMessage: 'Chart Copied',
  },
  DELETE: {
    id: 'DELETE',
    defaultMessage: 'Delete',
  },
  DONE: {
    id: 'DONE',
    defaultMessage: 'Done',
  },
});

function CardBase({ board, chart, renderRequired }) {
  const dispatch = useDispatch();
  const layout = useSelector(actions.selectLayout);
  const selectedChart = useSelector(actions.readStateSelectedChart);

  const editChart = () => {
    dispatch(actions.editMode(true));
    dispatch(actions.showRightSidebar(true));

    dispatch(actions.selectedChartId(chart?.id));
    dispatch(rememberBoard(board));

    /* attempt to scroll content container to top */
    setTimeout(() => { // put in a timeout so a render cycle can complete first
      try { // catch here because sometimes gridElement isn't found
        const gridElement = document.getElementById('content-container');
        gridElement.scrollTo(0, 0);
      } catch (e) {
        // i dont care do u
      }
    }, 1);
  };

  const saveChart = () => {
    dispatch(actions.isDirty(true));
    dispatch(actions.selectedChartId(false));
    dispatch(actions.showRightSidebar(false));
  };

  const handleDeleteChart = (closeSideSheet) => {
    dispatch(actions.isDirty(true));
    dispatch(rememberBoard(board));
    dispatch(deleteChart(chart.id));

    if (closeSideSheet) {
      dispatch(actions.selectedChartId(false));
      dispatch(actions.showRightSidebar(false));
    }
  };

  const sourcesAdded = chart?.data_sources && chart?.data_sources.length;

  let headerClass = styles.headerStandard;

  if (chart.properties && chart.properties.headerType) {
    if (chart.properties.headerType === 'Bottom') { headerClass = styles.headerBottom; }

    if (chart.properties.headerType === 'Label') { headerClass = styles.headerLabel; }

    if (chart.properties.headerType === 'None') { headerClass = styles.noHeader; }
  }

  if (!chart.data_sources || !chart.data_sources.length) {
    headerClass = 'Label';
  }

  const classes = [headerClass];

  if (chart?.type === 'Header') {
    classes.push(styles.header);
  } else {
    classes.push(styles.card);
    if (chart?.type === 'ResponsiveStat' && sourcesAdded) {
      classes.push(styles.cardSDP);
    }
  }

  if (layout?.editMode) { classes.push(styles.editModeCard); }

  return (
    <Card
      id={`chart_${chart?.id}`}
      className={classes.join(' ')}
    >
      {selectedChart?.id === chart?.id && (
        <div className={styles.floatingCardBtns}>
          <Tooltip disableFocusListener title={<FormattedMessage {...messages.DELETE} />}>
            <Fab className={styles.floatingDeleteBtn} onClick={() => handleDeleteChart(true)}>
              <DeleteIcon />
            </Fab>
          </Tooltip>

          <Tooltip disableFocusListener title={<FormattedMessage {...messages.DONE} />}>
            <Fab className={styles.floatingDoneBtn} onClick={saveChart}>
              <DoneIcon />
            </Fab>
          </Tooltip>
        </div>
      )}

      <ChartCard
        id={`card_container_${chart.id}`}
        chart={chart}
        deleteChart={() => handleDeleteChart()}
        editChart={editChart}
        renderRequired={renderRequired}
      />
    </Card>
  );
}

export default CardBase;
